import { NewsWidgetFactory } from '@/core/widgets/model/news-widget-factory';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { NewsWidget } from '@/core/widgets/model/news-widget';
import LocalWidgetRouter from '@/core/widgets/contexts/local-widget-router-context';
import { convertWidgetToReactPath } from '@/core/widgets/router/convert-widget-to-react-path';
import { WidgetContainerContext } from '@/core/widgets/contexts/widget-container-context';

export function WidgetFactoryWrapper({
  factory,
  url,
}: {
  factory: NewsWidgetFactory;
  url?: string;
}) {
  const { '*': spat, ...params } = useParams();
  const [searchParams] = useSearchParams();
  const [widget, setWidget] = useState<NewsWidget>();
  const [concretePath, setConcretePath] = useState<string>();
  const [initialUrl, setInitialUrl] = useState<string>();
  const [preferences, setPreferences] = useState<any>();
  const [widgetState, setWidgetState] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    let template = factory.path;
    let path = url;

    const paramsObject = Object.fromEntries(searchParams.entries());
    if (paramsObject) {
      setPreferences(paramsObject);
    }

    Object.keys(params).forEach(value => {
      template = template.replace(`:${value}`, params[value] || '');
    });
    setConcretePath(template);

    if (path && concretePath) {
      Object.keys(params).forEach(value => {
        path = path?.replace(`:${value}`, params[value] || '');
      });
      path = path?.replace(concretePath, '');
      setInitialUrl(path);
    }

    return () => {
      setPreferences(undefined);
    };
    // eslint-disable-next-line
  }, [url]);

  useEffect(() => {
    if (concretePath) setWidget(factory.createInstance(concretePath));
    // eslint-disable-next-line
  }, [concretePath]);

  if (widget) {
    document.title = widget.defaultTitle || '';

    return (
      <>
        <WidgetContainerContext.Provider
          value={{
            updateState<T>(state: Partial<T>): void {
              setWidgetState((prev: any) => ({ ...prev, ...state }));
            },
            getPreferences<T>(): T | undefined {
              return preferences;
            },
            setPreferences<T>(state: T): void {},
            setState<T>(state: T): void {
              setWidgetState(state);
            },
            updatePreferences<T>(state: Partial<T>): void {},
            getState() {
              return widgetState;
            },
            get widgetId(): string | undefined {
              return widget?.id;
            },
            close() {},
          }}
        >
          <LocalWidgetRouter
            widget={widget}
            path={initialUrl ?? spat}
            onNavigate={s => {
              console.log('Widget navigate:' + s);
              let routeVal = s;
              if (preferences) {
                const searchParams = new URLSearchParams(preferences).toString();
                routeVal += '?' + searchParams;
              }
              navigate(convertWidgetToReactPath(concretePath, routeVal));
            }}
          />
        </WidgetContainerContext.Provider>
      </>
    );
  }

  return <></>;
}
